import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import {
	filter,
	map,
	shareReplay,
	startWith,
	switchMap,
} from "rxjs/operators";
import { ComuneDTO } from "../../models/comune-dto";
import { LocalitaDTO } from "../../models/localita-dto";
import { Comune } from "../../models/portale/comune";
import { Localita } from "../../models/portale/localita";
import { ComponentOutputStatus } from "../../normalizzazione/component-output-status";
import { MessageService } from "../../services/message.service";
import { TerritorioService } from "../../services/territorio/territorio-service";

@Component({
	selector: "lib-localita",
	templateUrl: "./localita.component.html",
	styleUrls: ["./localita.component.css"],
})
export class LocalitaComponent implements OnInit, OnDestroy {

	form: FormGroup;

	@Input()
	viewOnly: boolean;

	@Input()
	localita: LocalitaDTO;

	@Input()
	province$: Observable<Array<Localita>>;

	@Output()
	done: EventEmitter<ComponentOutputStatus<LocalitaDTO>> = new EventEmitter<
		ComponentOutputStatus<LocalitaDTO>
	>();

	comuni$: Observable<Array<Comune>>;
	cap$: Observable<Array<string>>;
	subscription: Subscription;

	constructor(
		private msg: MessageService,
		private territorio: TerritorioService
	) { }

	ngOnInit() {
		this.form = new FormGroup({});
		if (!this.localita) {
			this.initLocalita();
		}
		const localitaProvincia = new FormControl(
			{ value: this.localita.provincia, disabled: this.viewOnly }, c => {
				if (this.viewOnly) return {};
				return String(c.value).trim().length > 0
					? {}
					: { required: true };
			}
		);
		this.form.addControl("localitaProvincia", localitaProvincia);

		const localitaComune = new FormControl(
			{ value: this.localita.comune, disabled: this.viewOnly }, c => {
				if (this.viewOnly) return {};
				return String(c.value).trim().length > 0
					? {}
					: { required: true };
			}
		);
		this.form.addControl("localitaComune", localitaComune);

		// if(this.viewCap) {
		const localitaCap = new FormControl(
			{ value: this.localita.cap, disabled: this.viewOnly }, c => {
				if (this.viewOnly) return {};
				return String(c.value).trim().length > 0
					? {}
					: { required: true };
			}
		);
		this.form.addControl("localitaCap", localitaCap);
		// }

		this.comuni$ = localitaProvincia.valueChanges.pipe(
			startWith(this.localita.provincia),
			filter((x) => x),
			switchMap((value) => this.territorio.getComuni$(value)),
			shareReplay()
		);

		this.cap$ = localitaComune.valueChanges.pipe(
			startWith(this.localita.comune),
			filter((comune: string) => comune != null),
			switchMap((codiceCatastale: string) => {
				return this.comuni$.pipe(
					map((comuni) => comuni.filter((comune) => comune.codiceCatastale === codiceCatastale)),
					filter((comuni) => comuni.length > 0),
					map((comuni) => comuni[0]),
					switchMap(comune => this.territorio.getCap$(comune.codiceIstat))
				);
			})
		);

		const changes$ = this.form.valueChanges.pipe(
			map((_) => {
				const localita = new LocalitaDTO();
				// if(this.viewCap) {
				localita.cap = this.form.controls["localitaCap"].value;
				// }
				localita.provincia = this.form.controls["localitaProvincia"].value;
				localita.comune = this.form.controls["localitaComune"].value;
				return ComponentOutputStatus.of(this.form.valid, localita);
			})
		);
		

		this.subscription = changes$.subscribe((_) => this.done.emit(_));

	}
	initLocalita() {
		this.localita = new LocalitaDTO();
	}

	compareComuni(c1: ComuneDTO, c2: ComuneDTO) {
		return c1 && c2 ? c1.cop === c2.cop : c1 === c2;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
